import {
  Component, Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { CreditDataType } from '@/api/homeV2Status/types';
import { AdjustTypeEnum } from '@/dict/quotaIncrease-type';

const style: Dictionary = require('./index.module.scss') as Dictionary;

const HomeStore = namespace('home');

@Component
export default class QuotaIncrease extends Vue {
  @HomeStore.State creditData!: CreditDataType | null;

  private get adjustText() {
    const { adjustQuota } = this.creditData || {};
    const { adjustType, adjustValue = 0, tempCreditExpiryTime = '' } = adjustQuota || {};
    if (Number(adjustValue)) {
      if (adjustType === AdjustTypeEnum.INCREASE) {
        return `额度已提升+${adjustValue}元`;
      }
      if (adjustType === AdjustTypeEnum.TEMP) {
        return `含临时额度${adjustValue}元，将于${tempCreditExpiryTime}到期`;
      }
      return '';
    }
    return '';
  }

  private render() {
    if (this.adjustText) {
      return (
        <div class={style.limitReminder}>
          <div class={style.contentIcon} />
          <div class={style.contentText}>{ this.adjustText }</div>
        </div>
      );
    }
    return null;
  }
}
